import css from './style.module.scss';
import Wrap from '../Wrap';
import Gallery from '../Gallery';
import { gql } from '../../util/fetchGql';
import Prose from '../Prose';
import Image from 'next/image';
import cls from '../../util/cls';

export const BRAND_CONTENT_FRAGMENT = gql`
	fragment BrandContent on brand_default_Entry {
		title
		images {
			id
			url @transform(
				width: 1600
				height: 1600
			)
			contain: url @transform(width: 1600)
			width
			height
		}
		text
		stacked
		backgroundColour
	}
`;

export default function BrandContent ({ title, images, text, stacked, backgroundColour, hasProducts }) {
	return (
		<>
			<Wrap wide grid className={css.brandContent}>
				<div className={cls(css.gallery, {
					[css.stacked]: stacked,
				})}>
					{stacked ? (
						<>
							{images.map(image => (
								<div key={image.id}>
									<Image unoptimized
										src={image.contain}
										width={1600}
										height={image.height / image.width * 1600}
									/>
								</div>
							))}
						</>
					) : (
						<Gallery
							unwrapped
							images={images}
						/>
					)}
				</div>
				<div className={cls(css.copy, css[backgroundColour])}>
					<Prose>
						{text}
					</Prose>
				</div>
			</Wrap>
			{hasProducts && (
				<Wrap className={css.subHeader}>
					<h2>The {title} Range</h2>
				</Wrap>
			)}
		</>
	);
}
